//DB: cherry pick Clerk IO to Live
e4.product = {
    debug: false,
    init: function () {
        if ( jQuery( '.js-e-jsonpublisher' ).length > 0 ) {
            e4.require.js( e4.settings.require.handlebars, function () {
                jQuery('.js-e-jsonpublisher').on('loaded.e4.jsonpublisher', function (event) {
                    e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-favorite-list');
                });
            });
        }
        if ( jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                // Variants is not yet ready for production.
                // e4.product.variants.init();
            } );
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-favorite-list');
            });
        }
        jQuery( '.js-e-product-images, #js-e-product-image-modal' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
            jQuery( event.target ).on( 'mouseenter', '.carousel-indicators li', function ( event ) {
                jQuery( event.target ).trigger( 'click' );
            } );
        } );
    },
    bindEvents: function () {
        var jProduct = jQuery( '.js-e-product' );
        jProduct.find( '.js-e-productlist-favorite-list-add-button' ).on( 'click', e4.product.toggleFavoriteCreateList );
        jProduct.on( 'click', '.js-e-productlist-favorite-list-add-button', e4.product.toggleFavoriteCreateList );
        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } );

        jQuery('.js-e-jsonpublisher').on('loaded.e4.jsonpublisher', function (event) {

            jQuery( event.target ).find( '.js-e-productlist-favorite-list-add-button' ).on( 'click', e4.product.toggleFavoriteCreateList );
            jQuery( event.target ).on( 'click', '.js-e-productlist-favorite-list-add-button', e4.product.toggleFavoriteCreateList );

            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        });

        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist inserted.e4.productlist loaded.e4.jsonpublisher', function ( event ) {
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );

        if ( jQuery( '.js-e-product-favorite-list-form' ).length > 0 ) {
            e4.product.favoritelist.bindEvents();
        }
    },
    toggleFavoriteCreateList: function ( event ) {
        event.preventDefault();
        event.stopPropagation();
        var jTarget = jQuery( event.target ).closest( '.js-e-productlist-favorite-list-container' ).find( '.js-e-product-favorite-list-add' );
        jTarget.collapse( 'toggle' );
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm );
        jForm.validate( {
            submitHandler: function ( domForm ) {
                if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( domForm );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( domForm );
                }
            }
        } );
    },
    addToCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        if(jForm.closest('.js-clerk-content').length > 0){
            var jElement = jForm.closest('.js-e-productlist-item').parent();
            var jParentElement = jForm.closest('.js-clerk-content').find('.e-productlist').find('.row').first();
            var intIndex = jParentElement.find(jElement).index();
            objFormData[ 'clerkRecommendation' ] = 'true';
            objFormData[ 'clerkIndex' ] = intIndex;
        }

        jQuery.extend( objFormData, {
            Redirect: false
        } );
        
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else if (jQuery( '.js-e-search-modal' ).hasClass('show')){
            e4.cart.addProductFromSearch(objFormData);
        }
        else {
            e4.cart.addProduct( objFormData );
        }
    },
    removeFromCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    },
    favoritelist: {
        init: function () {
            e4.product.favoritelist.bindEvents();
        },
        bindEvents: function () {
            var jListAddItem = jQuery( '.js-e-product-favorite-list-add-item' );
            jListAddItem.on( 'submit', '.js-e-product-favorite-list-form', function ( event ) {
                event.preventDefault();
            } ).on( 'click', '.js-e-product-favorite-list-add-button', function ( event ) {
                event.preventDefault();
                event.stopPropagation();
                var strTarget = jQuery( event.target ).data( 'target' );
                jQuery( event.target ).closest( '.js-e-product-favorite-list-add-item' ).find( strTarget ).collapse( 'toggle' );
            } );
            jQuery( document ).on( 'shown.bs.collapse', '.js-e-product-favorite-list-add', function ( event ) {
                jQuery( event.target ).find( '.js-e-product-favorite-list-form-add-name-input' ).trigger( 'focus' );
            } ).on( 'submit', '.js-e-product-favorite-list-form-add', e4.product.favoritelist.createList );
            jQuery( document ).on( 'change', '.js-e-favorite-list', function ( event ) {
                e4.product.favoritelist.toggleList( event.target );
            } );
        },
        toggleList: function ( domInput ) {
            var jInput = jQuery( domInput );
            if ( jInput.prop( 'checked' ) === true ) {
                e4.product.favoritelist.addToList( jInput );
            }
            else {
                e4.product.favoritelist.removeFromList( jInput );
            }
        },
        addToList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-add' ) + '&Redirect=false'
            }, function () {
                jInput.closest('.js-bloomingville-addtolist-wrapper').addClass('isInAnyList');
                jInput.prop( 'disabled', false );
            } );
        },
        addToNewList: function ( jForm ) {
            var jNewListInput = jForm.closest( '.js-e-productlist-favorite-list-container' ).find( '.js-e-favorite-list' ).last();
            jNewListInput.prop( 'checked', true ).trigger( 'change' );
        },
        removeFromList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-remove' ) + '&Redirect=false'
            }, function () {
                var jElement = jInput.closest('.js-bloomingville-addtolist-wrapper');
                if (jElement.find( '.js-e-favorite-list:checked' ).length === 0) {
                    jElement.removeClass('isInAnyList');
                }
                jInput.prop( 'disabled', false );
            } );
        },
        createList: function ( event ) {
            event.preventDefault();
            var jForm = jQuery( event.target ),
                jFormInput = jForm.find( '.js-e-product-favorite-list-form-add-name-input' );
            if ( jFormInput.val() !== '' ) {
                e4.cc.ajax( {
                    url: jForm.attr( 'action' ),
                    data: jForm.serialize()
                }, function () {
                    e4.product.favoritelist.getListData( jForm );
                    jQuery( '.js-e-product-favorite-list-add' ).collapse( 'hide' );
                } );
            }
            else {
                jFormInput.trigger( 'focus' );
            }
        },
        getListData: function ( jForm ) {
            var objProductDataSettings = jForm.closest( '.js-e-productlist-favorite-list-container' ).data();

            jQuery.ajax( {
                method: 'POST',
                url: e4.settings.ecom.favoritelists.url,
                dataType: 'json',
                data: objProductDataSettings
            } ).done( function ( jsonData ) {
                e4.product.favoritelist.buildList( jsonData, jForm );
                e4.product.favoritelist.addToNewList( jForm );
            } );
        },
        buildList: function ( jsonData, jForm ) {
            jForm.closest( '.js-e-productlist-favorite-list-container' ).find( '.js-e-product-favorite-list-form' ).html( e4.handlebars.tmpl.favoriteList( jsonData ) );
        }
    }
};
